import { Permission } from 'constants/permission'
import { hasAccessToMaximize, NavigationConfigFunctions, UserSectionNavigationName } from 'legacy/navigation/common'
import { LegacyPermission } from 'legacy/navigation/permission'
import { hasPermission } from 'legacy/navigation/utils'
import { AccountPermissions, NavigationSection } from 'legacy/types/osWebRootApi'

export const navigation: NavigationConfigFunctions = {
  dashboard: (permissions: AccountPermissions[]): NavigationSection => [
    {
      title: 'OS_HEADER.HEADER.YOU',
      path: '/you',
    },
    {
      title: 'OS_HEADER.HEADER.NETWORK',
      path: '/network/contacts',
      disabled: !hasPermission(permissions, Permission.NETWORK_APP_ACCESS),
    },
    {
      title: 'OS_HEADER.HEADER.APPS',
      path: '/apps/list',
      disabled: !hasPermission(permissions, Permission.APPS_APP_ACCESS),
    },
  ],
  main: (permissions: AccountPermissions[], countryCode?: string): NavigationSection => [
    {
      title: 'OS_HEADER.NAVIGATION_MAIN.OPTIMISE',
      nav: [
        {
          title: 'OS_HEADER.NAVIGATION_MAIN.AUDIENCES',
          path: '/audiences/map',
          disabled:
            !hasAccessToMaximize(countryCode) || !hasPermission(permissions, LegacyPermission.MxmzAudiencesAppAccess),
        },
        {
          title: 'OS_HEADER.NAVIGATION_MAIN.TOUCHPOINTS',
          path: '/touchpoints/touchpoints',
          disabled:
            !hasAccessToMaximize(countryCode) || !hasPermission(permissions, LegacyPermission.MxmzTouchpointsAppAccess),
        },
        {
          title: 'OS_HEADER.NAVIGATION_MAIN.ARCHITECT_JUNIOR',
          path: '/junior',
          disabled:
            !hasAccessToMaximize(countryCode) || !hasPermission(permissions, LegacyPermission.MxmzJuniorAppAccess),
          hidden:
            !hasAccessToMaximize(countryCode) || !hasPermission(permissions, LegacyPermission.MxmzJuniorAppAccess),
        },
        {
          title: 'OS_HEADER.NAVIGATION_MAIN.CAMPAIGNS_PARENT',
          disabled:
            !hasAccessToMaximize(countryCode) ||
            (!hasPermission(permissions, LegacyPermission.MxmzCampaignsAppAccess) &&
              !hasPermission(permissions, LegacyPermission.MxmzMediaPlansComparisonAppAccess)),
          nav: [
            {
              title: 'OS_HEADER.NAVIGATION_MAIN.CAMPAIGNS',
              path: '/briefs/list',
              disabled: !hasPermission(permissions, LegacyPermission.MxmzCampaignsAppAccess),
            },
            {
              title: 'OS_HEADER.NAVIGATION_MAIN.MP_UPLOADER',
              path: '/custom-campaigns/list',
              hidden: !hasPermission(permissions, LegacyPermission.MxmzMediaPlansUploaderAppAccess),
            },
            {
              title: 'OS_HEADER.NAVIGATION_MAIN.MP_COMPARISON',
              path: '/mp-comparison/list',
              disabled: !hasPermission(permissions, LegacyPermission.MxmzMediaPlansComparisonAppAccess),
            },
          ],
        },
      ],
    },
  ],
  avatarNavigation: (permissions: AccountPermissions[]): NavigationSection => [
    {
      title: 'OS_HEADER.HEADER.ADMINISTRATION',
      nav: [
        {
          title: 'OS_HEADER.HEADER.APP_SETTING',
          hidden: !hasPermission(permissions, Permission.APPS_MARKET_MANAGE),
          path: '/apps/admin-panel',
        },
        {
          title: 'OS_HEADER.HEADER.MARKET',
          hidden: !hasPermission(permissions, LegacyPermission.OsWorkspaceManage),
          path: '/market-admin/panel',
        },
      ],
    },
    {
      title: 'OS_HEADER.HEADER.PERMISSIONS',
      nav: [
        {
          title: 'OS_HEADER.HEADER.ROLES',
          hidden: !hasPermission(permissions, LegacyPermission.AdminAppAccess),
          path: '/os-admin/panel/roles',
        },
        {
          title: 'OS_HEADER.HEADER.USERS',
          hidden: !hasPermission(permissions, LegacyPermission.AdminAppAccess),
          path: '/os-admin/panel/users',
        },
        {
          title: 'OS_HEADER.HEADER.GROUPS',
          hidden: !hasPermission(permissions, LegacyPermission.AdminAppAccess),
          path: '/os-admin/panel/groups',
        },
      ],
    },
    {
      title: 'OS_HEADER.HEADER.USER',
      nav: [
        {
          title: 'OS_HEADER.HEADER.PROFILE',
          disabled: !hasPermission(permissions, Permission.OS_USERDETAILS_APP_ACCESS),
          path: '/user/profile',
        },
        {
          title: 'OS_HEADER.HEADER.ACCOUNT_SETTINGS',
          path: '/user/settings',
        },
        {
          title: 'OS_HEADER.HEADER.FEEDBACK',
          disabled: true,
          path: 'userFeedback',
        },
        {
          title: 'OS_HEADER.HEADER.LOGOUT',
          path: 'logout',
        },
      ],
    },
  ],
  userSection: (): NavigationSection => [
    {
      title: UserSectionNavigationName.community,
      hidden: false,
      disabled: true,
    },
    {
      title: UserSectionNavigationName.help,
      hidden: false,
      disabled: false,
      nav: [
        {
          title: UserSectionNavigationName.helpTrainingPortal,
          hidden: true,
          disabled: true,
        },
        {
          title: UserSectionNavigationName.helpProductTour,
          hidden: false,
          disabled: false,
        },
      ],
    },
  ],
  userSettings: (permissions: AccountPermissions[]): NavigationSection => [
    {
      title: 'OS_HEADER.HEADER.PROFILE',
      path: '/user/profile',
      disabled: !hasPermission(permissions, Permission.OS_USERDETAILS_APP_ACCESS),
    },
    {
      title: 'OS_HEADER.HEADER.ACCOUNT_SETTINGS',
      path: '/user/settings',
    },
  ],
  networkSection: (): NavigationSection => [
    {
      title: 'OS_HEADER.HEADER.CONTACTS',
      path: 'contacts',
      disabled: false,
    },
  ],
}
